import React from 'react';
import type { CreditCardNotificationsProps } from '../types/credit-card.types';

const CreditCardNotifications: React.FC<CreditCardNotificationsProps> = ({ shopifyData }) => {
  const handleContinueToStore = () => {
    // Redirecionar diretamente para a homepage da loja
    // Tenta homePage primeiro, depois corsUrl como fallback
    if (shopifyData?.store?.homePage) {
      window.location.href = shopifyData.store.homePage;
    } else if (shopifyData?.store?.corsUrl) {
      window.location.href = shopifyData.store.corsUrl;
    } else {
      console.warn('Homepage ou corsUrl da loja não encontrados');
    }
  };

  return (
    <div className="text-center space-y-4">
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
        <h3 className="text-lg font-semibold text-blue-800 dark:text-blue-200 mb-2">
          📧 Verifique seu E-mail
        </h3>
        <p className="text-blue-700 dark:text-blue-300 text-sm">
          Enviamos um e-mail de confirmação com todos os detalhes do seu pedido. 
          Verifique também sua caixa de spam.
        </p>
      </div>

      <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4">
        <h3 className="text-lg font-semibold text-green-800 dark:text-green-200 mb-2">
          🎉 Obrigado pela Compra!
        </h3>
        <p className="text-green-700 dark:text-green-300 text-sm">
          Seu pedido está sendo processado e você será notificado sobre cada etapa do envio.
        </p>
      </div>

      <div className="pt-4">
        <p className="text-sm text-text-secondary dark:text-gray-400">
          Em caso de dúvidas, entre em contato conosco através do e-mail de confirmação.
        </p>
      </div>

      {/* Botão para continuar à loja */}
      <div className="mt-6 text-center">
        <button
          onClick={handleContinueToStore}
          className="text-white font-semibold py-3 px-6 rounded-lg transition duration-150 text-base btn-primary"
        >
          Continuar à Loja
        </button>
      </div>
    </div>
  );
};

export default CreditCardNotifications; 